import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const loggedInUser = localStorage.getItem("user");
  const user = JSON.parse(loggedInUser);

  if (!user?.userid) return <Navigate to="/login" replace />;
  return <Outlet />;
};

export default ProtectedRoute;
